function controlPoints(points, coord) {
  const n = points.length - 1;
  const tmp = Array(n);
  tmp[0] = points[0].pos[coord] + 2 * points[1].pos[coord];
  for (let i = 1; i < n - 1; ++i) {
    tmp[i] = 4 * points[i].pos[coord] + 2 * points[i + 1].pos[coord];
  }
  tmp[n - 1] = 4 * points[n - 1].pos[coord] + 0.5 * points[n].pos[coord];
  const x = Array(n);
  let b = 2.0;
  x[0] = tmp[0] / b;
  for (let i = 1; i < n; ++i) {
    const t = tmp[i];
    tmp[i] = 1 / b;
    b = (i < n - 1 ? 4.0 : 3.5) - tmp[i];
    x[i] = (t - x[i - 1]) / b;
  }
  for (let i = 1; i < n; ++i) {
    x[n - i - 1] -= tmp[n - i] * x[n - i];
  }
  return x;
}

export default function buildSpline(points) {
  if (points.length <= 1) return;
  if (points.length === 2) {
    const [x0, y0] = points[0].pos;
    const [x1, y1] = points[1].pos;
    return [
      [(2 * x0 + x1) / 3],
      [(2 * y0 + y1) / 3],
      [(x0 + 2 * x1) / 3],
      [(y0 + 2 * y1) / 3],
    ];
  }

  const n = points.length - 1;
  const x = controlPoints(points, 0);
  const y = controlPoints(points, 1);

  const x2 = Array(n);
  const y2 = Array(n);
  for (let i = 0; i < n; ++i) {
    const xn = points[i + 1].pos[0], yn = points[i + 1].pos[1];
    x2[i] = (i < n - 1 ? 2 * xn - x[i + 1] : (xn + x[n - 1]) / 2);
    y2[i] = (i < n - 1 ? 2 * yn - y[i + 1] : (yn + y[n - 1]) / 2);
  }

  return [x, y, x2, y2];
}
